import { render } from "./OnlinePlayingStatus.vue?vue&type=template&id=e495714e&scoped=true"
import script from "./OnlinePlayingStatus.vue?vue&type=script&lang=js"
export * from "./OnlinePlayingStatus.vue?vue&type=script&lang=js"

import "./OnlinePlayingStatus.vue?vue&type=style&index=0&id=e495714e&scoped=true&lang=css"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e495714e"]])

export default __exports__